import React from 'react';
import classNames from 'classnames';
export function FormFieldLabel({ children, className, for: htmlFor, notion = false, testId }) {
    const componentLabelClass = classNames('c-form-field__label', className).trim();
    return (React.createElement("label", { "data-testid": testId, htmlFor: htmlFor, className: componentLabelClass },
        children,
        notion && React.createElement("span", { className: "c-form-field__notion" }, "*")));
}
